import { Editor } from "@tinymce/tinymce-react";
import React, { useEffect, useState } from "react"
const FormEditors = ({ value, onChange }) => {
useEffect(() => {
  const handler = (e) => {
    if (e.target.closest(".tox-tinymce-aux, .moxman-window, .tam-assetmanager-root") !== null) {
      e.stopImmediatePropagation();
    }
  };
  document.addEventListener("focusin", handler);
  return () => document.removeEventListener("focusin", handler);
}, []);
  return (
    <React.Fragment>
      <Editor
      value={value}
 onEditorChange={(newValue, editor) => {
onChange(newValue)
}}
/>
    </React.Fragment>
  )
}

export default FormEditors
